var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.058824 0 0 0 0 0.086275 0 0 0 0 0.101961 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.2 .2)",
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.376 19.6H.308V6.52h4.068V19.6zM2.362 4.725c-.641 0-1.195-.233-1.662-.7-.467-.467-.7-1.02-.7-1.663C0 1.721.233 1.167.7.7 1.167.233 1.72 0 2.362 0c.642 0 1.196.233 1.663.7.467.467.7 1.02.7 1.662 0 .642-.233 1.196-.7 1.663-.467.467-1.02.7-1.663.7zM19.602 19.6h-4.07v-6.387c0-1.05-.087-1.809-.262-2.275-.32-.788-.948-1.182-1.881-1.182-.934 0-1.59.35-1.969 1.05-.292.525-.437 1.298-.437 2.32V19.6H6.958V6.52h3.893v1.794h.044c.292-.584.758-1.065 1.4-1.444.7-.467 1.517-.7 2.45-.7 1.896 0 3.223.598 3.981 1.794.584.962.875 2.45.875 4.462V19.6z",
    fill: "#12171A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.249b4433.svg";
export { ForwardRef as ReactComponent };